(() => {
  $crisp.push([
    'on',
    'session:loaded',
    () => {
      let status = $crisp.is('website:available') ? 'online' : 'offline';
      if (status === 'online') {
        if (document.getElementById('status'))
          document.getElementById('status').innerText = 'Live chat with a team member';
        document.getElementById('footer__status').innerHTML =
          '<div style="display: flex;align-items: center;position: absolute;justify-content: center;top: 0;font-size: 10px;left: 6px;"><div style="border-radius: 50%;height: 6px;width: 6px;/* position: absolute; */flex-shrink: 0;background: linear-gradient(0deg, #18b71c 0%, #92c50f 100%);margin-right: 3px;/* margin-left: -3px; */">&nbsp;</div>online</div>Start Chat';
        document.getElementById('contact__status').innerHTML =
          '<div style="display: flex;align-items: center;position: absolute;justify-content: center;top: 0;font-size: 10px;left: 6px;"><div style="border-radius: 50%;height: 6px;width: 6px;/* position: absolute; */flex-shrink: 0;background: linear-gradient(0deg, #18b71c 0%, #92c50f 100%);margin-right: 3px;/* margin-left: -3px; */">&nbsp;</div>online</div>Start Chat';
        Array.from(document.querySelectorAll('.js-help-message')).forEach(
          (statusElement) => (statusElement.innerText = 'Live chat with a team member')
        );
      }
      const now = new Date();
      const dateString = now.toLocaleString('en-US', { timeZone: 'America/Chicago', hour12: false });
      const [datePart, timePart] = dateString.split(', ');
      const [month, dayOfMonth, year] = datePart.split('/').map(Number);
      const [hour, minute] = timePart.split(':').map(Number);
      const dateObject = new Date(
        `${year}-${month.toString().padStart(2, '0')}-${dayOfMonth.toString().padStart(2, '0')}T${hour
          .toString()
          .padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`
      );
      const day = dateObject.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday

      let onlineStatus = 'offline';
      if (day !== 0 && day !== 6 && ((hour >= 8 && hour < 17) || (hour === 17 && minute <= 30))) {
        onlineStatus = 'online';
      }

      const chatWithUsText = onlineStatus === 'online' ? 'Chat with us' : 'Leave a message';
      const crispButton =
        document.querySelector('#crisp-chatbox-button') ||
        document.querySelector('.crisp-client div[aria-label="Open chat"]');
      if (crispButton) {
        crispButton.style.setProperty('display', 'flex', 'important');
        crispButton.style.setProperty('align-items', 'center', 'important');
        crispButton.style.setProperty('background', 'linear-gradient(0deg, #18b71c 0%, #92c50f 100%)', 'important');
        crispButton.style.setProperty('border-radius', '4px', 'important');
        crispButton.style.setProperty('border-radius', '99vh', 'important');
        crispButton.children[1].style.setProperty('background-color', 'transparent', 'important');
        crispButton.children[1].style.setProperty('box-shadow', 'none', 'important');
      }
      if (onlineStatus === 'online') {
        const dot = document.createElement('p');
        dot.className = `crisp-mobile-hidden online-indicator online-indicator--active js-online-indicator`;
        dot.style.setProperty('position', 'absolute', 'important');
        dot.style.setProperty('bottom', '1px', 'important');
        dot.style.setProperty('right', '3px', 'important');
        dot.style.setProperty('border-radius', '50%', 'important');
        dot.style.setProperty('display', 'flex', 'important');
        dot.style.setProperty('align-items', 'center', 'important');
        dot.style.setProperty('gap', '4px', 'important');
        dot.style.setProperty('margin', '0', 'important');
        dot.style.setProperty('font-size', '12px', 'important');
        dot.style.setProperty('color', 'var(--lime)', 'important');
        dot.innerHTML = `
            <span 
                class="online-indicator__dot" 
                style="
                    border: 1px solid white !important; 
                    flex-shrink: 0 !important; 
                    display: flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    width: 10px !important;
                    height: 10px !important;
                    margin: 0 !important;
                    background-color: #0fcc45 !important;
                    border-radius: 50% !important;
                    position: relative !important;
                "
            >
                <span 
                    class="online-indicator__blink" 
                    style="
                        display: block !important;
                        width: 100% !important;
                        height: 100% !important;
                        background-color: #0fcc45 !important;
                        border-radius: 50% !important;
                        animation: blink 3s linear infinite !important;
                    "
                >
            </span>
        </span>`;
        crispButton.appendChild(dot);
      }

      if (window.innerWidth > 1024) {
        crispButton.style.setProperty('padding-right', '16px', 'important');
        const chatWithUsElement = document.createElement('span');
        chatWithUsElement.innerText = chatWithUsText;
        chatWithUsElement.className = 'crisp-mobile-hidden';
        chatWithUsElement.style.setProperty('color', 'white', 'important');
        chatWithUsElement.style.setProperty('font-family', 'Roboto, sans-serif', 'important');
        chatWithUsElement.style.setProperty('font-size', '20px', 'important');
        crispButton.appendChild(chatWithUsElement);
      }

      window.toggleIndicators();
      $crisp.push([
        'on',
        'chat:opened',
        () => {
          document.querySelector('#google-merchantwidget-iframe-wrapper').style.zIndex = '50';
        },
      ]);
      $crisp.push([
        'on',
        'chat:closed',
        () => {
          document.querySelector('#google-merchantwidget-iframe-wrapper').style.zIndex = '2147483647';
        },
      ]);
      $crisp.push(['set', 'session:data', [[['last-viewed', document.title]]]]);
    },
  ]);
})();
